import http from '@/api/http';
import { Toast } from 'vant';

function addreport(params) {
  const loading = Toast.loading({
    message: '提交中...',
    forbidClick: true,
    loadingType: 'spinner'
  });
  http
    .post(`${window.configs['fe.api']}/api/v1/addreport`, params)
    .then(res => {
      loading.clear();
      if (res.status === 0) {
        Toast.success('投诉成功，请耐心等待回复。');
      } else {
        Toast.fail(res.message || '提交失败，稍后再试。');
      }
    })
    .catch(err => {
      loading.clear();
      Toast.fail(err.message || '提交失败，稍后再试。');
    });
}

function getfeedback(data) {
  const loading = Toast.loading({
    message: '数据获取中...',
    forbidClick: true,
    loadingType: 'spinner'
  });
  const { access_token } = data;
  return http
    .get(
      `${window.configs['fe.api']}/api/v1/getfeedback`,
      access_token ? undefined : data,
      access_token
        ? {
            headers: {
              access_token
            }
          }
        : null
    )
    .then(res => {
      loading.clear();
      if (res.status === 0) {
        return res.data;
      } else {
        Toast.fail(res.message || '数据获取失败，稍后再试。');
      }
    })
    .catch(err => {
      loading.clear();
      Toast.fail(err.message || '提交失败，稍后再试。');
    });
}

function reportsms(tel) {
  return http
    .get(`${window.configs['fe.api']}/api/v1/reportsms`, { tel })
    .then(res => {
      if (res.status === 0) {
        Toast.success('发送成功~');
        return res.data;
      } else {
        Toast.fail({ message: res.message });
      }
    })
    .catch(err => {
      Toast.fail(err.message || '提交失败，稍后再试。');
    });
}

function getreport(params) {
  return http
    .get(`${window.configs['fe.api']}/api/v1/getreport`, params)
    .then(res => {
      if (res.status === 0) {
        return res.data;
      } else {
        Toast.fail({ message: res.message });
        return null;
      }
    })
    .catch(err => {
      Toast.fail(err.message || '请求失败，请稍后再试。');
    });
}

function reportinfo(id) {
  return http
    .get(`${window.configs['fe.api']}/api/v1/reportinfo`, { id })
    .then(res => {
      if (res.status === 0) {
        return res.data;
      } else {
        Toast.fail({ message: res.message });
      }
    })
    .catch(err => {
      Toast.fail(err.message || '请求失败，请稍后再试。');
    });
}

export { addreport, getfeedback, reportsms, getreport, reportinfo };
